import { render } from "./WorkChecklist.vue?vue&type=template&id=4577a15f"
import script from "./WorkChecklist.vue?vue&type=script&lang=js"
export * from "./WorkChecklist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__